export const TWO_FA_OTP_TYPE = {
    EMAIL: 'email',
    PHONE: 'phone',
    EITHER: 'either', //for internal purpose. generally we only have email or phone
};

export const TWO_FA_ERRORS = {
    INVALID_OTP: 'OTP is invalid.',
    EXPIRED_OTP: 'OTP is expired.',
    SESSION_EXPIRED:
        'Unfortunately your previous session has expired. Please contact your administrator for further steps.',
};

export const TWO_FA_SUCCESS = {
    [TWO_FA_OTP_TYPE.EMAIL]: 'Email has been verified.',
    [TWO_FA_OTP_TYPE.PHONE]: 'Phone number has been verified.',
};

export const TWO_FA_SESSION_PROPERTY = {
    OTP_ATTEMPTS: 'leftOtpAttempts',
    PII_ATTEMPTS: 'leftPiiUpdateAttempts',
};

export const TWO_FA_ERROR_CODES = {
    USER_2FA_VERIFIED: 'USER_2FA_VERIFIED',
    USER_2FA_SESSION_EXPIRED: 'USER_2FA_SESSION_EXPIRED',
    USER_EMAIL_VERIFIED: 'USER_EMAIL_VERIFIED',
    USER_PHONE_NO_VERIFIED: 'USER_PHONE_NO_VERIFIED',
    USER_PII_UPDATE_FORBIDDEN: 'USER_PII_UPDATE_FORBIDDEN',
    USER_TWO_FA_ATTEMPTS_EXHAUSTED: 'USER_TWO_FA_ATTEMPTS_EXHAUSTED',
    USER_TWO_FA_OTP_EXPIRED: 'USER_TWO_FA_OTP_EXPIRED',
};

export const AUTH_DB_VERIFICATION_DECISION = {
    ASK_FOR_FALLBACK: 'ASK_FOR_FALLBACK',
    PASS: 'PASS',
};
